import { Pipe, PipeTransform } from '@angular/core';
import { ApiConnection } from '../service/apiConnection';

@Pipe({ name: 'mediaUrl' })
export class MediaUrlPipe implements PipeTransform {
  transform(signedPath: string | undefined | null, fallbackPath?: string): string {
    const path = signedPath || fallbackPath;
    if (!path) return '';
    // Already an absolute URL (e.g. a legacy stored logoPath): leave untouched.
    if (/^[a-z][a-z0-9+.-]*:\/\//i.test(path)) return path;
    const base = ApiConnection.FILE_SERVER_URL.replace(/\/+$/, '');
    return base + (path.startsWith('/') ? path : '/' + path);
  }
}
